import React from 'react'
import palette from 'utils/styles/palette.js';
import styled from 'styled-components';

export default function Foorter () {
  return (
    <div style={{borderTop:"1px solid #424242",minWidth:"1680px", width:"100%",height:"55px",background:palette.footer, zIndex:3, position:"fixed", bottom:0,  display:"flex",alignItems:"center"}}>
     <FooterCare>
          ( C ) 2024. IoT 구서트랩 ( Care 1 ) Co.All rights reserved. 
     </FooterCare>
     </div>
  );
}
const FooterCare = styled.div`
  width:100%; 
  color:${palette.footerFont};
  font-size:12px;
  line-height:5.5vh; 
  text-align: center;

`;